module.exports = __webpack_public_path__ + "img/gao_2.6729ba7d.jpg";